<template>
	<div id="checkout-detail">
    <div style="background: #fff">
    <h1 class="text-center py-2 pt-6 font-normal">Checkout detail</h1>
    <vs-divider class="mb-0"></vs-divider>

    <div class="flex checkout-detail-content">
      <div class="lg:w-3/4 md:w-2/3 w-1/2 flex flex-col align-center position-relative" :class="{'overflow-hidden': isActiveSearch}">
        <div class="pt-base w-full h-full overflow-auto flex justify-center" style="background: #f7f7f8;">
          <div class="w-11/12">
            <!-- <div class="mb-6 pb-5"> -->
                <vx-card>
                  <div class="flex py-6">
                    <div class="vx-col w-1/12 flex justify-center font-bold text-lg">1</div>
                    <div class="w-9/12">
                      <div class="font-bold text-xl pb-2">Beo beo beo</div>
                      <div class="text-light">10:30 with Wendy Smith</div>
                    </div>
                    <div class="w-2/12 text-right px-6">
                      <div class="flex align-center justify-end">
                        d223
                        <feather-icon icon="XIcon" svgClasses="w-5 h-5 stroke-current text-danger ml-4"/>
                      </div>
                    </div>
                  </div>
                </vx-card>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div class="lg:w-1/4 md:1/3 w-1/2 h-full position-relative border-left-custom">
        <!-- <VuePerfectScrollbar :settings="psSettings"> -->
          <div class="py-6 border-bottom-custom" style="background: #fbfbfb;">
            <vs-input
              icon="search"
              icon-after="true"
              label-placeholder="Search for customer"
              class="mx-auto mt-0"
              style="width: 90%;"
            />
          </div>
          <div style="max-height: calc(100% - 200px) !important; overflow: auto; background: #f7f7f8;">
              zsdfzfzs
          </div>

          <div class="flex flex-col align-center py-6 border-top-custom w-full" style="position:absolute; bottom: 0; left: 0;">
          <!-- <vs-button color="primary" type="border">Primary</vs-button> -->
          <!-- <p class="pb-4 font-bold">
            Total:
            <span class="ml-1 text-underline">đ</span>
            <span>0</span>
            <span class="ml-1">(1h)</span>
          </p> -->
          <!-- <vs-row>
            <vs-button type="filled" class="font-bold sm:text-xs text-sm shadow-md vx-col w-custom ml-auto py-4 px-2" style="background: #fff !important; color: #000">EXPRESS CHECKOUT</vs-button>
            <vs-button color="dark" type="filled" class="font-bold sm:text-xs text-sm shadow-md vx-col w-custom mx-auto py-4 px-2">SAVE APPOINTMENT</vs-button>
          </vs-row> -->
          </div>
        <!-- </VuePerfectScrollbar> -->
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    itemInfo: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
  #checkout-detail {
    .add-popup-content {
      height: calc(100% - 130px);
      .index-icon {
          width: 30px;
          height: 30px;
          background: #efefef;
      }
      .w-custom {
          width: calc(50% - 25px);
      }
      .svg-icon {
          width: 68px;
          height: 68px;
          margin: 60px 0 20px;
      }
      .background-close {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          position: absolute;
          top: 0;
          left: 0;
          display: none;

          .close-button {
              opacity: 0;
              cursor: pointer;

              .close-icon {
                  width: 50px;
                  height: 50px;
                  background: #fff;
                  border-radius: 50%;
              }
          }
          &:hover {
              .close-button {
                  opacity: 0.8;
                  &:hover {
                      opacity: 1;
                  }
              }
          }
      }
      .show-search {
          display: unset !important;
      }
      .show-not-search {
          display: none !important;
      }
    }
  }
</style>
